module.exports = __webpack_public_path__ + "img/jarvanvi.2b61f6ac.jpg";